/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './job-spec-rest.service';
export * from './job-spec.dto';
export * from './job-spec.mapper';
